import {keepOnly} from "../../../../../common/utils/objects";

export const applyResultCart = (resultCart) => (cart) => ({
    ...cart,
    ...keepOnly(resultCart, ["appliedPayments", "shipping", "appliedCredits", "paymentErrors", "items"]),
});
